function isRefCleanup(value) {
    return typeof value === 'function';
}
/**
 * Функция, которая сливает несколько рефов в один
 * @typeParam RefValue тип значения, которое хранится в рефе
 * @param refs рефы, которые нужно слить в один реф
 * @returns Возвращает реф-коллбэк, внутри которого передастся значение всем рефам-аргументам
 * @example
 * ```typescript
 *
 * const Example = forwardRef(function Example(
 *     {},
 *     ref
 * ) {
 *     const localRef = useRef(null)
 *     return (
 *         <div ref={mergeRefs(ref, localRef)} />
 *     )
 *```
 */
export function mergeRefs(...refs) {
    return (value) => {
        const cleanups = refs.map(ref => {
            if (typeof ref === 'function') {
                const cleanup = ref(value);
                return isRefCleanup(cleanup) ? cleanup : undefined;
            }
            else if (ref != null) {
                ref.current = value;
            }
            return undefined;
        });
        if (cleanups.some(isRefCleanup)) {
            return () => {
                for (const [index, ref] of refs.entries()) {
                    const cleanup = cleanups[index];
                    if (cleanup) {
                        cleanup();
                    }
                    else if (typeof ref === 'function') {
                        ref(null);
                    }
                    else if (ref != null) {
                        ref.current = null;
                    }
                }
            };
        }
        return undefined;
    };
}
